<template>
 <v-dialog v-model="importDialog" persistent width="40%">
    <v-card class="py-2 px-3">
      <v-card-title primary-title>
        <div class="title">{{$t('screener.import_registrants.title')}}</div>
        <v-spacer></v-spacer>
        <v-btn
          class="mx-0"
          small
          dark
          icon
          color="grey"
          @click.native="reset()"
        >
          <v-icon small>$vuetify.icons.rms_close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="importForm" onsubmit="return false;">
          <ExcelFileUploader
          :fileName.sync="fileName"
          :file.sync="fileObject"
          :url.sync="url"
          :mimeType="'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
          @onUploadSelectedFileClick="onUploadSelectedFileClick"
          ></ExcelFileUploader>
        <v-checkbox
          single-line
          v-model="shouldGeneratePassword"
          color="primary"
          :label="$t('screener.import_registrants.password_generation')">
        </v-checkbox>
      <v-text-field
          v-if="shouldGeneratePassword"
          :prepend-inner-icon="$vuetify.icons.rms_password"
          :label="$t('screener.password.title')"
          v-model="password"
          single-line
          :rules="shouldGeneratePassword ? [rules.required, rules.min_length(6)] : []"
        ></v-text-field>
        </v-form>
      </v-card-text>
      <!-- <v-divider></v-divider> -->
      <v-card-actions class="px-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" outline @click="reset">{{$t('screener.btn.close')}}</v-btn>
          <v-btn color="primary" outline @click="onUploadSelectedFileClick">{{$t('screener.btn.import')}}</v-btn>
      </v-card-actions>
      <v-card-text class="px-3 pt-0">
      <v-divider class="my-3"></v-divider>
        <Faqs class="mt-3" :faqs="DEFINES.IMPORT_REGISTRANTS_FAQS"></Faqs>
      </v-card-text>
    </v-card>
 </v-dialog>
</template>

<script>
import rules from '@/validation';
import Faqs from "@/components/FAQs";
import ExcelFileUploader from "@/components/ExcelFileUploader";

export default {
    name:"ImportConsumers",
    props:{
        importDialog:{
            type:Boolean,
            default:false
        },
        screener:{
            type:Object,
            default:null
        }
    },
    components:{
      Faqs,
      ExcelFileUploader
    },
    data(){
        return {
            rules,
            fileName: '',
            fileObject: null,
            url:'',
            shouldGeneratePassword:0,
            password:123456
        }
    },
    methods:{
      reset() {
          this.$emit('update:importDialog',false);
          this.$refs.importForm.reset();
          this.fileName = '';
          this.fileObject = null;
      },
    async onUploadSelectedFileClick() {
      // A file is not chosen!
      if (!this.fileObject) {
        return this.$store.dispatch('app/showMessage', {
          message: 'Please select a file first',
          color: 'error',
        });
      }

      if(!this.$refs.importForm.validate()){
        return false;
      }

      let payload = new FormData();
      payload.append('file', this.fileObject);
      payload.append('screener_id', this.screener.id);
      payload.append('shouldGeneratePassword', this.shouldGeneratePassword); // FormDara sends boolean values as strings
      payload.append('password', this.password);

      try {
        var response = await this.$store.dispatch(
          'screener/importConsumers',
          payload,
        );
        this.$store.dispatch('app/showMessage', {
          message: 'The file has been uploaded. You will be notified over email shortly',
          color: 'success',
        });
        this.reset();
      } catch (error) {
        this.reset();
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  }
}
</script>

<style>

</style>
